import { RouteName } from "constants/route";
import { ISosPublicDetailResponse } from "models/sos";
import { Link } from "react-router-dom";

interface IProps {
  sos: ISosPublicDetailResponse;
}

export default function SosInfo({ sos }: IProps) {
  return (
    <div className="w-full">
      <div className="w-10 h-10">
        <img
          src={sos.user.image}
          alt={"0"}
          className="rounded-full object-cover w-full h-full"
        />
      </div>
      <h1 className="mt-1 text-black font-semibold text-base">
        {sos.user.first_name} {sos.user.last_name}
      </h1>
      <div className="w-full flex flex-col gap-2 mt-2">
        <div className="flex gap-x-1">
          <p className="text-xs">Phone</p>
          <p className="text-xs px-2 pb-0.5 pt-0 w-fit">{sos.user.phone}</p>
        </div>
        <div className="flex gap-x-1">
          <Link
            to={RouteName.TRIP_DETAIL.replace(":id", sos.trip_id)}
            className="text-xs font-medium bg-yellow-400 px-2 pb-1 pt-0.5 rounded-lg border-none w-full text-center text-black hover:border-none focus-visible:border-none active:border-none"
          >
            View Trip
          </Link>
        </div>
      </div>
    </div>
  );
}
